var STATE_DEFAULT = {
  windowWidth: 0,
  windowHeight: 0,
  windowScrollTop: 0,
  isMobileWidth: false,
  isPhabletWidth: false,
  isDesktopWidth: true
};
export var DEVICE_INFO_UPDATE = 'DEVICE_INFO_UPDATE';
export default function device() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STATE_DEFAULT;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case DEVICE_INFO_UPDATE:
      return Object.assign({}, state, action.value);

    default:
      return state;
  }
}